// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"_7Byzu","block":"zEsqS","title":"ejvJl","textAccent":"dVi7r"};